var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01879 9.40623C5.87033 9.40623 4.86417 8.63324 4.3177 7.48322H7.93189V5.88949H3.89766C3.88761 5.76057 3.88219 5.63143 3.88219 5.49954C3.88219 5.36889 3.88757 5.23816 3.89766 5.11097H7.93196V3.51692H4.31773C4.86421 2.36701 5.87033 1.59427 7.01883 1.59427C8.11653 1.59427 9.15015 2.3291 9.71617 3.51115L11.1543 2.82379C10.3206 1.08156 8.7361 0 7.01879 0C5.72782 0 4.52286 0.589911 3.62584 1.66251C3.17469 2.20209 2.82998 2.83168 2.60336 3.51692H0.869873V5.11094H2.29961C2.29193 5.23897 2.28796 5.36973 2.28796 5.4995C2.28796 5.63062 2.29193 5.75972 2.29961 5.88945H0.869873V7.48319H2.60336C2.82998 8.16835 3.17469 8.79724 3.62587 9.33632C4.5229 10.409 5.72785 11 7.01883 11C8.73617 11 10.3206 9.91858 11.1543 8.17639L9.71617 7.48775C9.15012 8.67133 8.11649 9.40623 7.01879 9.40623Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroIcon);
export default __webpack_public_path__ + "static/media/euroIcon.ea162014ad69cd841d91f1eb834a47cc.svg";
export { ForwardRef as ReactComponent };